import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import "../css/app.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ProfileInformation from "./pages/Profileinformation";
import ContactAdmin from "./pages/Contactadmin";
import ProtectedRoute from "./components/ProtectedRoute";
import { AppProvider, useApp } from "./components/Appcontext";
import Profile from "./pages/Profile";
import FindFriend from "./pages/FindFriend";
import FriendRequest from "./pages/FriendRequest";
import Connection from "./pages/Connection";
import Events from "./pages/Events";
import UserProfile from "./pages/UserProfile";
import Notification from "./pages/Notification";
import Groups from "./pages/Groups";
import Settings from "./pages/Settings";
import UpdateProfile from "./pages/UpdateProfile";
import Group from "./pages/Group";
import Landing from "./pages/Landing";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPendingAccounts from "./pages/admin/AdminPendingAccounts";
import AdminPendingPosts from "./pages/admin/AdminPendingPosts";
import AdminActivityLogs from "./pages/admin/AdminActivityLogs";
import AdminManager from "./pages/admin/AdminManager";
import AdminCommitteeMembers from "./pages/admin/AdminCommitteeMembers";

function App() {
  const { Leftmenu, setLeftmenu } = useApp();
  const { Rightmenut, setRightmenu } = useApp();
  const { search, setSearch } = useApp();
  const location = useLocation(); // works now

  const linkchange = () => {
    setLeftmenu(false);
    setRightmenu(false);
    setSearch(false);
  };

  useEffect(() => {
    linkchange();
  }, [location]);

  return (
    <div className="main-wrapper color-theme-red">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/landing" element={<Landing />} />
        <Route element={<ProtectedRoute allowPartial />}>
          <Route path="/profile-information" element={<ProfileInformation />} />
          <Route path="/contact-admin" element={<ContactAdmin />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/logout" element={<Navigate to="/login" />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/:id" element={<UserProfile />} />
          <Route path="/find-connections" element={<FindFriend />} />
          <Route path="/friend-request" element={<FriendRequest />} />
          <Route path="/connections" element={<Connection />} />
          <Route path='/notifications' element={<Notification />} />
          <Route path='/groups' element={<Groups />} />
          <Route path="/group/:id" element={<Group />} />
          <Route path="/events" element={<Events />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/update-profile/:type" element={<UpdateProfile />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/pending-accounts" element={<AdminPendingAccounts />} />
          <Route path="/admin/pending-posts" element={<AdminPendingPosts />} />
          <Route path="/admin/activity-logs" element={<AdminActivityLogs />} />
          <Route path="/admin/admin-manager" element={<AdminManager />} />
          <Route path="/admin/committee-members" element={<AdminCommitteeMembers />} />
        </Route>
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

const container = document.getElementById("app");
if (container) {
  const root = createRoot(container);
  root.render(
    <AppProvider>
      <AppWrapper />
    </AppProvider>
  );
}